import { Link, useLocation } from 'react-router-dom';
import WomanImg from '../img/home/Home.png';
import BackgroundImage from '../img/home/Background.jpg';
import BackgroundImage1 from '../img/home/Background1.png';
import { motion } from 'framer-motion';
import { transition1 } from '../transitions';

const Home = () => {
  const containerStyle = {
    background: `url(${BackgroundImage}) center/cover`,
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'rgba(255, 255, 255, 0.8)', // Adjust the background color opacity
    
  };

  const textContainerStyle = {
    position: 'relative',
    zIndex: '1',
    color: 'rgba(255, 255, 255, 0.9)', // Off-white text color
    
  };

  const imageContainerStyle = {
    position: 'relative',
    overflow: 'hidden',
    transition: 'transform 0.3s ease-in-out',
    marginBottom: '20px',
    
  };

  const imageStyle = {
    maxWidth: '100%',
    height: 'auto',
    opacity: 1, // Adjust the WomanImg opacity
  };

  const hoverImage = () => {
    document.getElementById('image-container').style.transform = 'scale(1.1)';
  };

  const unhoverImage = () => {
    document.getElementById('image-container').style.transform = 'scale(1)';
  };

  return (
    <motion.section
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={transition1}
      className='section'
      style={containerStyle}
    >
      <div className='container mx-auto h-full relative' style={textContainerStyle}>
        <div className='flex flex-col justify-center'>
          <motion.div
            initial={{ opacity: 0, y: '-50%' }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: '-50%' }}
            transition={transition1}
            className='w-full pt-36 pb-14 lg:pt-0 lg:pb-0 lg:w-auto z-10 lg:absolute flex flex-col justify-center items-center lg:items-start'>
            <h1 className='h1 text-center lg:text-left'>
              A group of <br /> Wedding Photography
            </h1>
            <p className='text-[26px] lg:text-[36px] font-primary mb-4 lg:mb-12'>
              Chandannagar, Hooghly, WB
            </p>
            <Link to={'/contact'} className='btn mb-[30px]'>
              Hire me
            </Link>
          </motion.div>
          <div
            className='flex justify-end max-h-96 lg:max-h-max'
            style={imageContainerStyle}
            id='image-container'
            onMouseEnter={hoverImage}
            onMouseLeave={unhoverImage}
          >
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              exit={{ sclae: 0 }}
              transition={transition1} className='relative overflow-hidden'>
              <img src={WomanImg} alt='' className='hidden lg:block' style={imageStyle} />
            </motion.div>
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default Home;
